import {ApiRequest} from "~/utils/api-request";
import cookie from "~/utils/cookie";

let api_url = (cookie.authToken.value()) ? 'lots/counts/for-my' : 'lots/counts';

let apiRequest = new ApiRequest('get', api_url);

apiRequest.onSuccess((data) => {
    // console.log(data);
});

apiRequest.onError((error) => {
    // errors

});

const getLotsCounts = async() => {
    return apiRequest.request(true);
}

const lotsCountsRefresh = async() => {
    apiRequest = new ApiRequest('get', api_url);
}

export {getLotsCounts, lotsCountsRefresh};